const TRAIN_STRINGS = [
  "Esse processo pode demorar um pouco...",
  "Deixe a aba aberta e volte daqui a pouco",
  "Procurando aquela pessoa 10/10",
  "Calculando o que você acha especial",
  "Buscando seu príncipe encantado",
  "Logo, logo....",
  "Achando o amor da sua vida!",
  "Julgando seu gosto....uau...",
  "Trazendo a pessoa amda",
  "Está quase lá, só mais um pouco...",
]

export default TRAIN_STRINGS;